<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 ref="dashboardPranesimai" class="mb-4">Pranešimai</h3>

    <dashboard-pranesimai-search
      :loading="loading"
      @search="searchDashboardPranesimai"
      @scollToPranesimai="scollToPranesimai"
    />

    <v-data-table
      class="mb-4"
      :loading="loading"
      :headers="headers"
      :items="filterItemList"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.pranesimas`]="{ item }">
        <div class="nowrap">
          <el-byla v-for="byla in item.bylos" :key="byla.byl_id" :byla="byla" />
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @viewItem="editItem(item)"
          @priskirtiItem="startPriskyrimas(item)"
          @cancelPriskirtiItem="cancelPriskyrimas(item)"
        />
        <v-tooltip top v-if="item.zus_priskirta_snau_id">
          <template v-slot:activator="{ on, attrs }">
            <v-chip small outlined class="mt-1 mb-1" v-bind="attrs" v-on="on">
              <div class="tikrina-chip text-truncate">
                Priskirta {{ item.zus_priskirta }}
              </div>
            </v-chip>
          </template>
          <div class="tooltip-text">
            Priskirta<br />
            {{ item.zus_priskirta }}
          </div>
        </v-tooltip>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template slot="loading">
        kraunasi
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-confirm
      title="Pranešimo priskyrimas"
      :text="confirmText"
      :item="confirmItem"
      action="Priskyrimas"
      v-model="showConfirm"
      @confirmPriskyrimas="confirmPriskyrimas"
      @cancelConfirm="cancelConfirm"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../../mixins/math'
import userRole from '../../../mixins/userRole'
import DashboardPranesimaiSearch from './DashboardPranesimaiSearch'
import ModalConfirm from '../../modals/ModalConfirm'

export default {
  name: 'DashboardPranesimai',
  components: {
    DashboardPranesimaiSearch,
    ModalConfirm,
  },
  mixins: [math, userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      pranesimai: [],
      search: null,
      headers: [
        {
          text: 'Gauto pranešimo registracijos numeris',
          align: 'start',
          value: 'zus_numeris',
        },
        {
          text: 'Dokumento numeris',
          align: 'start',
          value: 'dokumento_numeris',
        },
        {
          text: 'Identifikavimo kodas (IDK)',
          align: 'start',
          value: 'identifikavimo_kodas',
        },
        {
          text: 'Pranešimo data',
          align: 'start',
          value: 'pranesimo_data',
        },
        {
          text: 'Gauto pranešimo rūšis',
          align: 'start',
          value: 'dokumento_rusis',
        },
        {
          text: 'Adresato el. paštas',
          align: 'start',
          value: 'zus_adresato_el_pastas',
        },
        {
          text: 'Dokumentai',
          align: 'center',
          sortable: false,
          value: 'pranesimas',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      itemsPerPageOptions: [5, 10, 50],
      pagination: {
        page: 1,
        pageSize: 5,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
      searchData: {},
      confirmText: null,
      confirmItem: null,
      showConfirm: false,
    }
  },
  computed: {
    ...mapGetters(['userID', 'objektasID', 'hipotekaTipas']),

    filterItemList() {
      return this.pranesimai.map(item => {
        item.bylos = item.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `byla/${byla.byl_id}/${byla.byl_hash}/content`,
            pranesimas_numeris: item.zus_numeris,
          }
        })

        item.canView = item.obj_id !== null || item.pra_id !== null
        item.canPriskirti = false
        item.canCancelPriskirti = false

        if (this.isJuridinis && item.priskiriamas) {
          const priskirtaSau = item.zus_priskirta_snau_id === this.userID
          item.canPriskirti = !priskirtaSau
          item.canCancelPriskirti = priskirtaSau
        }
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 5
    },
    isJuridinis() {
      return this.roleOr(['DT_JA', 'DT_JA_Skaito'])
    },
  },
  created() {
    // this.getData()
  },
  methods: {
    getData(resetPageNr = false) {
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`pagrindinis/registratoriaus-pranesimai`, data)
        .then(res => {
          this.pranesimai = res.data.zurnalas_siunciami
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchDashboardPranesimai(searchData) {
      this.searchData = searchData
      this.getData(true)
    },
    editItem(item) {
      if (item.pra_id) {
        const prasymasID = item.pra_id
        this.$router.push({
          name: 'regPrasymasDuomenys',
          params: {
            prasymasID: prasymasID,
          },
        })
        return
      }
      const objektasID = item.obj_id
      this.$router.push({
        name: 'hipotekaPranesimas',
        params: {
          objektasID: objektasID,
        },
      })
    },
    startPriskyrimas(item) {
      this.priskirtiItem(item, true)
    },
    cancelPriskyrimas(item) {
      this.priskirtiItem(item, false)
    },
    priskirtiItem(item, priskirti, force = false) {
      const data = {
        zus_id: item.zus_id,
        priskirti: priskirti,
        force: force,
      }

      this.$axios
        .post(
          `pagrindinis/registratoriaus-pranesimai/${item.zus_id}/priskirti`,
          data
        )
        .then(res => {
          const priskyrimas = res.data.priskyrimas

          if (priskyrimas.success) {
            window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
            this.getData()
            return
          }

          item.zus_priskirta = priskyrimas.zus_priskirta
          item.zus_priskirta_snau_id = priskyrimas.zus_priskirta_snau_id
          this.openConfirmPriskyrimas(item)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          //
        })
    },
    openConfirmPriskyrimas(item) {
      this.confirmText = `Pranešimas jau yra priskirtas <b>${item.zus_priskirta}</b>. <br />Ar tikrai norite pranešimą priskirti sau?`
      this.confirmItem = item
      this.showConfirm = true
    },
    confirmPriskyrimas(item) {
      this.priskirtiItem(item, true, true)
    },
    cancelConfirm() {
      this.showConfirm = false
    },
    scollToPranesimai() {
      if (this.$refs.dashboardPranesimai) {
        this.$vuetify.goTo(this.$refs.dashboardPranesimai)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.tikrina-chip {
  max-width: 110px;
}
</style>
